import { useState } from 'react';
import DownloadDrawerEcho from './DownloadDrawerEcho';
import type { DateRange, SelectedNetwork } from '@/types';
import { useShowPerformanceQuery } from '@/services/revenueApi';
import { useFilterContext, useDerivedNetworkContext } from '@/context';
import { mixpanelTrack } from '@/utils/mixpanelUtils/asyncMixpanel';
import { MIXPANEL_EVENT, RevenueDashboardWidget } from '@/utils/mixpanelUtils/events';
import { DownloadButtonEcho } from '../DownloadButton/DownloadButtonEcho';

const useShowPerformanceData = (
  selectedNetwork: SelectedNetwork | undefined,
  drawerDateRange: DateRange,
  isDrawerOpen: boolean
) => {
  return useShowPerformanceQuery(
    selectedNetwork?.id ?? '',
    drawerDateRange.from,
    drawerDateRange.to,
    {
      enabled: isDrawerOpen,
    }
  );
};

const DownloadDrawerTrigger = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { selectedNetwork } = useDerivedNetworkContext();
  const { filters } = useFilterContext();

  const { data } = useShowPerformanceData(selectedNetwork, filters.dateRange, isOpen);

  const handleOpen = () => {
    setIsOpen(true);
    mixpanelTrack(MIXPANEL_EVENT.earnings.downloadDrawer.opened, {
      widget: RevenueDashboardWidget.DownloadDrawer,
      page: 'earnings',
    });
  };

  return (
    <>
      <DownloadButtonEcho onClick={handleOpen} />
      <DownloadDrawerEcho
        isOpen={isOpen}
        handleClose={() => setIsOpen(false)}
        selectedNetwork={selectedNetwork}
        globalFilters={filters}
        shows={data ?? []}
      />
    </>
  );
};

export default DownloadDrawerTrigger;
